import React from "react";
import "../About/Aboutus.css";
import group from '../../Assets/img/Group.png';
import group1 from '../../Assets/img/Group (1).png';
const AboutUsPreview = ({ previewService, setShowPreviewAboutUs }) => {
    const service = previewService;
    const [openSection, setOpenSection] = React.useState("vision");
    if (!service) return null;

    return (
        <div className="about-preview-overlay" onClick={() => setShowPreviewAboutUs(false)}>
            <div className="about-preview-modal" onClick={(e) => e.stopPropagation()}>

                {/* Close Button */}
                <button
                    className="about-preview-close"
                    onClick={() => setShowPreviewAboutUs(false)}
                >
                    ✕
                </button>

                {/* HEADER */}
                <div className="service-preview-header">
                    <h1>About Us</h1>
                    <p>Home &gt; <span className="about-preview-subtitle">About Us</span></p>
                </div>

                <div className="about-preview-wrapper">

                    {/* LEFT SIDE */}
                    <div className="about-preview-left">
                        <p className="about-preview-subtitle">ABOUT US</p>

                        <h1 className="about-title">{service.heading}</h1>

                        <div
                            className="about-preview-description"
                            dangerouslySetInnerHTML={{ __html: service.description }}
                        />

                        {/*              ACCORDION STARTS HERE           */}
                        <div className="accordion mt-4">

                            {/* OUR VISION */}
                            <div className="accordion-item border-0 mb-3">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2 ${openSection !== "vision" ? "collapsed" : ""
                                            }`}
                                        type="button"
                                        onClick={() => setOpenSection("vision")}
                                    >
                                        <span className="arrow-symbol"></span>
                                        <span>{service.visionTitle}</span>
                                    </button>
                                </h2>

                                {openSection === "vision" && (
                                    <div className="accordion-body ps-0 text-muted pt-3"
                                        dangerouslySetInnerHTML={{ __html: service.visionDescription }}
                                    />
                                )}
                            </div>

                            {/* OUR VALUE */}
                            <div className="accordion-item border-0">
                                <h2 className="accordion-header">
                                    <button
                                        className={`accordion-button ps-0 bg-transparent shadow-none fw-semibold d-flex align-items-center gap-2 ${openSection !== "value" ? "collapsed" : ""
                                            }`}
                                        type="button"
                                        onClick={() => setOpenSection("value")}
                                    >
                                        <span className="arrow-symbol"></span>
                                        <span>{service.valueTitle}</span>
                                    </button>
                                </h2>

                                {openSection === "value" && (
                                    <div className="accordion-body ps-0 text-muted pt-3"
                                        dangerouslySetInnerHTML={{ __html: service.valueDescription }}
                                    />
                                )}
                            </div>

                        </div>


                    </div>
                    
                    {/*                 RIGHT SIDE IMAGES             */}

                    <div className="image-stack col-6 mt-5 ms-lg-0 mb-5 mb-lg-0">
                        <img src={group} className="doodle-left" alt="doodle" />
                        <img src={group1} className="doodle-right" alt="doodle" />


                        {/* Back image */}
                        {service.image2 && (
                            <img
                                src={service.image2}
                                className="stack-img img-back"
                                alt="about-back"
                            />
                        )}

                        {/* Front image */}
                        {service.image1 && (
                            <img
                                src={service.image1}
                                className="stack-img img-front"
                                alt="about-front"
                            />
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default AboutUsPreview;
